import React from 'react';
import { Code2, Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#080E23] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center space-x-3">
     
             
            <img
              src="/src/assets/logoModelos3.png"
              alt="ModeloSmart Logo"
              style={{ height: "120px", width: "auto" }}
            />
         
            </div>
            <p className="text-gray-300 leading-relaxed max-w-md">
              Más de 30 años transformando empresas con soluciones tecnológicas innovadoras. 
              Especializados en desarrollo de software, inteligencia artificial y automatización de procesos.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3 text-gray-300">
                <Mail className="h-4 w-4" />
                <span>info@modelosmart.com</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Phone className="h-4 w-4" />
                <span>+52 (81) 1255-1972</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <MapPin className="h-4 w-4" />
                <span>Monterrey Nuevo León, México</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Enlaces Rápidos</h4>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('inicio')}
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Inicio
              </button>
              <button
                onClick={() => scrollToSection('servicios')}
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Servicios
              </button>
              <button
                onClick={() => scrollToSection('experiencia')}
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Experiencia
              </button>
              <button
                onClick={() => scrollToSection('tecnologias')}
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Tecnologías
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Contacto
              </button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Servicios</h4>
            <div className="space-y-3 text-gray-300">
              <div>Desarrollo Móvil</div>
              <div>Aplicaciones Web</div>
              <div>Software de Escritorio</div>
              <div>Inteligencia Artificial</div>
              <div>Automatización N8N</div>
              <div>Consultoría Tecnológica</div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              © {currentYear} ModeloSmart. Todos los derechos reservados.
            </div>

            {/* Social Media */}
            <div className="flex items-center space-x-6">
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>

            {/* Legal Links */}
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Aviso de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;